import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Tooltip,
} from '@mui/material';

import { getDisabledChainTooltipText } from 'modules/chains/utils/getDisabledChainTooltipText';
import { useTreeStyles } from 'modules/common/styles/useTreeStyles';

import { useChainTypeSelectorWithSubchainsStyles } from './useChainTypeSelectorWithSubchainsStyles';
import {
  IChainTypeSelectorProps,
  useChainTypeSelectorWithSubchains,
} from './useChainTypeSelectorWithSubchains';
import { SubchainSelector } from './SubchainSelector';

export const ChainTypeSelectorWithSubchains = ({
  chain,
  endpoints,
  hasPremiumColor,
  isLastChainInProject,
  isLastPathSelected,
  isLoading,
  selectedChainPaths,
  setSelectedChainPaths,
  shouldAvoidChainNameFormatting,
  subchains,
  typeName,
}: IChainTypeSelectorProps) => {
  const {
    allPaths,
    handleChangeChild,
    handleChangeParent,
    isLastSelectedGroup,
    isParentChecked,
    isParentIndeterminate,
  } = useChainTypeSelectorWithSubchains({
    chain,
    endpoints,
    hasPremiumColor,
    selectedChainPaths,
    setSelectedChainPaths,
    subchains,
    typeName,
    isLoading,
  });

  const { classes: classesTree } = useTreeStyles();
  const { classes, cx } = useChainTypeSelectorWithSubchainsStyles();

  if (!subchains?.length || !allPaths?.length) {
    return null;
  }

  const isParentDisabled =
    (isParentChecked || isParentIndeterminate) &&
    (Boolean(isLastSelectedGroup && isLastChainInProject) ||
      Boolean(isLastPathSelected));

  return (
    <FormControl className={classes.parentFormControl}>
      <Tooltip
        placement="left"
        title={getDisabledChainTooltipText(isParentDisabled)}
      >
        <FormControlLabel
          control={
            <Checkbox
              disabled={isLoading || isParentDisabled}
              className={classes.chainCheckbox}
              checked={isParentChecked}
              indeterminate={isParentIndeterminate}
              onClick={handleChangeParent}
            />
          }
          label={
            <span
              className={cx({
                [classes.hasPremiumColor]: hasPremiumColor,
              })}
            >
              {typeName}
            </span>
          }
        />
      </Tooltip>

      {subchains?.length > 1 && (
        <Box className={cx(classesTree.treeWrapper, classes.childrenWrapper)}>
          <>
            {subchains.map(subChain => (
              <SubchainSelector
                isLoading={isLoading}
                key={subChain.id}
                classes={{
                  root: cx(classesTree.treeItem, classes.childSelector),
                }}
                checkBoxClassName={classes.chainCheckbox}
                subChain={subChain}
                endpoints={endpoints}
                selectedChainPaths={selectedChainPaths}
                shouldAvoidChainNameFormatting={shouldAvoidChainNameFormatting}
                handleChangeChild={handleChangeChild}
                isDisabled={isLastPathSelected}
              />
            ))}
          </>
        </Box>
      )}
    </FormControl>
  );
};
